import Swiper from 'swiper';

export default function slidersInits() {
    // Home slider
    if ( document.querySelectorAll('.swiper-slide').length > 1) {
        const homeSlider = new Swiper('.homeslider-container', {
            autoplay: {
                delay: 5000
            },
            pagination: {
                el: '.homeslider-pagination',
                clickable: true
            }
        });
    }

    var gallerySlider = new Swiper('.galleryslider-container', {
        slidesPerView: 3,
        spaceBetween: 30,
        autoHeight: true,
        observer: true,
        observeParents: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 30,
            }
        }
    });

    var newsSlider = new Swiper('.newsslider-container', {
        slidesPerView: 2,
        spaceBetween: 30,
        autoHeight: true,
        observer: true,
        //observeParents: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 30,
            }
        }
    });
//
}



// WEBPACK FOOTER //
// ./components/sliders-inits.js